import config from "@Config/index";
import axios from "axios";

const initiateBookformAPI = async (inventory_id: number, source: string) => {
  try {
    await axios.put(
      `${config.API_URL}/api/v0/user_flow/inventory/${inventory_id}/initiate_book_form`,
      {},
      {
        withCredentials: true,
      },
    );
  } catch (error) {
    if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
      console.error("Bookform initiate", source);
    }
  }
};

export default initiateBookformAPI;
